module.exports = __webpack_public_path__ + "img/car1_3.09903ceb.png";